const config = {
  apiBaseUrl: 'https://backend.smartinvestment.info', 
};

export default config;
